/**
 * Re-sorts PLP/search grids by the visible (translated) title using the
 * storefront locale's dictionary order. Shopify/Liquid title sort is Unicode,
 * so letters like É, Ś, ü, á otherwise land in the wrong place.
 */
(function () {
  const SORT_ATTR = 'data-lw-title-sort';
  const SORTED_ATTR = 'data-lw-title-sorted';

  function resolveLocale(grid) {
    const pathSeg = (window.location.pathname.split('/')[1] || '').replace('_', '-');
    if (/^[a-z]{2}-[a-z]{2}$/i.test(pathSeg)) return pathSeg;
    return (
      (grid && grid.getAttribute('data-lw-collator-locale')) ||
      document.documentElement.lang ||
      undefined
    );
  }

  function collatorFor(locale) {
    try {
      return new Intl.Collator(locale, { numeric: true });
    } catch (e) {
      return new Intl.Collator(undefined, { numeric: true });
    }
  }

  function itemTitle(el) {
    const link = el.querySelector('.card-title a');
    if (link && link.textContent) return link.textContent.trim();
    return (el.getAttribute('data-lw-sort-title') || '').trim();
  }

  function syncDatalayer(sortedItems) {
    const script = document.getElementById('lw-datalayer-item-list-json');
    if (!script || !script.textContent) return;
    try {
      const data = JSON.parse(script.textContent);
      if (!data || !Array.isArray(data.items)) return;

      const byName = new Map();
      data.items.forEach((item) => {
        const key = String(item.item_name || '');
        if (!byName.has(key)) byName.set(key, []);
        byName.get(key).push(item);
      });

      const next = [];
      sortedItems.forEach((el, index) => {
        const bucket = byName.get(itemTitle(el));
        const item = bucket && bucket.shift();
        if (!item) return;
        item.index = index;
        next.push(item);
      });
      byName.forEach((bucket) => {
        bucket.forEach((item) => next.push(item));
      });

      data.items = next;
      script.textContent = JSON.stringify(data);
    } catch (e) {
      /* leave original payload */
    }
  }

  function sortGrid(grid) {
    try {
      const direction = (grid.getAttribute(SORT_ATTR) || '').toLowerCase();
      if (direction !== 'title-ascending' && direction !== 'title-descending') return;

      const items = Array.from(grid.children).filter(
        (el) => el.classList.contains('product') && !el.classList.contains('product--empty')
      );
      const empties = Array.from(grid.children).filter((el) => el.classList.contains('product--empty'));

      if (items.length > 1) {
        const collator = collatorFor(resolveLocale(grid));
        const factor = direction === 'title-descending' ? -1 : 1;
        items.sort((a, b) => factor * collator.compare(itemTitle(a), itemTitle(b)));
        const frag = document.createDocumentFragment();
        items.forEach((el) => frag.appendChild(el));
        grid.appendChild(frag);
        empties.forEach((el) => grid.appendChild(el));
        syncDatalayer(items);
      }
    } catch (e) {
      /* keep Liquid order */
    } finally {
      grid.setAttribute(SORTED_ATTR, '');
    }
  }

  function run() {
    document.querySelectorAll('.productGrid[' + SORT_ATTR + ']').forEach(sortGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
